import type { TreeNodeTest } from 'shared/types'
import { client } from '../clients'

const getMany = (deviceId: string) =>
  client.get<TreeNodeTest[]>(`/estimate/devices/${deviceId}`)

export const questions = {
  getMany
}
